export const isSafePassword = (value: string | null | undefined): boolean => {
    if (!value) return false;

    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
    return regex.test(value);
}
